import { timeRanges } from '@/services/dashboard-service/dashboard.service.types';

type ReadableStorage = Pick<Storage, 'getItem'>;

export const DEFAULT_TIME_RANGE = '7d';

const isKnownPreset = (value: string | undefined): boolean =>
  !!value && (timeRanges as readonly string[]).includes(value);

type StoredTimeRange = {
  timeRange: string | undefined;
  startTime: string | undefined;
  endTime: string | undefined;
};

/**
 * Url-first, synchronously at store creation: seeding from localStorage alone would
 * make render 1 of a shared `?time_range=` link query the stored window instead.
 */
export function resolveStoredTimeRange(search: string, storage: ReadableStorage): StoredTimeRange {
  const params = new URLSearchParams(search);
  const urlStart = params.get('start_time') || undefined;
  const urlEnd = params.get('end_time') || undefined;
  const urlRange = params.get('time_range') || undefined;

  if (urlStart && urlEnd) {
    return { timeRange: undefined, startTime: urlStart, endTime: urlEnd };
  }
  // An unknown preset would survive every reload while crm-django quietly served 7d,
  // leaving no button pressed and no Custom pill.
  if (isKnownPreset(urlRange)) {
    return { timeRange: urlRange, startTime: undefined, endTime: undefined };
  }

  const storedStart = storage.getItem('selectedStartTime') || undefined;
  const storedEnd = storage.getItem('selectedEndTime') || undefined;

  if (storedStart && storedEnd) {
    return { timeRange: undefined, startTime: storedStart, endTime: storedEnd };
  }

  const stored = storage.getItem('selectedTimeRange') || undefined;

  return {
    timeRange: isKnownPreset(stored) ? stored : DEFAULT_TIME_RANGE,
    startTime: undefined,
    endTime: undefined,
  };
}
